module.exports = __webpack_public_path__ + "static/media/vodacom.82ebd3e9.png";